import { log } from "./commons";

export const PSEUDO_BLOCK_WHITELIST = [];

export const enrichPropsWithAttributes = (
  props,
  ancestralAttributes = {},
  newAttributes = {}
) => {
  const GROUPED_ATTRIBUTE_DELIMITER = "|";
  const { attributes: thisAttributes = {} } = props;
  const attributes = [
    ...Object.entries(thisAttributes),
    ...Object.entries(ancestralAttributes),
    ...Object.entries(newAttributes)
  ];

  // Group attributes with same key from anscestral and new attributes
  // e.g. { 'data-pzn-id': '123|456' }
  const enrichedAttributes = attributes.reduce((acc, [key, value]) => {
    if (value == null) {
      // Skip undefined or null values
      return acc;
    }

    if (!(key in acc)) {
      acc[key] = value;
    } else if (
      typeof acc[key] === "string" &&
      !acc[key].split(GROUPED_ATTRIBUTE_DELIMITER).includes(value)
    ) {
      acc[key] = `${acc[key]}${GROUPED_ATTRIBUTE_DELIMITER}${value}`;
    }
    return acc;
  }, {});

  return {
    ...props,
    attributes: enrichedAttributes
  };
};

const PSEUDO_BLOCK_HANDLERS = {};
export const makePseudoBlockAttributes = (block, metaData, logTrace) => {
  const { blockName } = block;
  let newAttributes = {};
  if (blockName in PSEUDO_BLOCK_HANDLERS) {
    newAttributes = PSEUDO_BLOCK_HANDLERS[blockName](block, metaData, logTrace);
  }

  log.debug(
    `${logTrace};EVENT_NAME=EVENT_BLOCK_PARSER_PSEUDO_BLOCK_HANDLER;BLOCK_NAME=${blockName};ATTRIBUTES=${JSON.stringify(
      newAttributes
    )}`
  );

  return newAttributes;
};

const registerPseudoBlockHandler = (blockName, handler) => {
  PSEUDO_BLOCK_HANDLERS[blockName] = handler;
  PSEUDO_BLOCK_WHITELIST.push(blockName);
};

registerPseudoBlockHandler(
  "helix-common/pzn-container-block",
  (block, metaData /*logTrace*/) => {
    let { pznRecDetailsArr = [] } = metaData;
    if ("pznRecDetails" in metaData) {
      // to handle different name for same array in granular-pzn
      pznRecDetailsArr = metaData.pznRecDetails;
    }

    const { accessPoint } = block;

    let pznData = pznRecDetailsArr.find(
      (pznObj) => pznObj.personalization_placement === accessPoint
    );

    return {
      "data-pzn-placement": pznData?.personalization_placement,
      "data-pzn-id": pznData?.personalization_id,
      "data-pzn-action": pznData?.personalization_action,
      "data-pzn-model-name": pznData?.model_name,
      "data-pzn-model-version": pznData?.model_version,
      "data-pzn-workflow": pznData?.personalization_workflow
    };
  }
);

registerPseudoBlockHandler(
  "gwp-components/reusable-block",
  (block /*metaData, logTrace*/) => {
    const {
      props: { externalContentIdentifier }
    } = block;
    if (externalContentIdentifier) {
      return {
        "data-cas-id": externalContentIdentifier
      };
    }
  }
);
